import React, { ChangeEvent } from 'react';
import { observer } from 'mobx-react';
import { UpgradeMain } from './UpgradeMain';
import { IParkingProductUpgrade } from '../../../../domain/parking-product/models/IParkingProductUpgrade';
import { trackToggleUpgrade } from '../../shared/analytics/custom/trackToggleUpgrade';
import { useToggleUpgrade } from './helpers/useToggleUpgrade';
import { useIsSelected } from './helpers/useIsSelected';

interface IUpgradeProps {
	upgrade: IParkingProductUpgrade;
}

export const Upgrade = observer(({ upgrade }: IUpgradeProps) => {
	const toggleUpgrade = useToggleUpgrade();
	const isSelected = useIsSelected(upgrade.id);

	const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		const isChecked = e.target.checked;

		toggleUpgrade(upgrade, isChecked);

		trackToggleUpgrade(upgrade, isChecked);
	};

	return (
		<UpgradeMain
			upgrade={upgrade}
			isSelected={isSelected}
			handleChange={handleChange}
		/>
	);
});
